var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { setCSSCustomProperty } from "./utils/css.utils";
import { tick } from "./utils/tick";
export var UIController = {
    init: function () {
        UIController.initNavListeners();
        // UIController.initGPDRManager();
    },
    initNavListeners: function () {
        var windowResizeHandler = function () {
            var _a, _b, _c;
            var adminBar = document.querySelector("#wpadminbar");
            setCSSCustomProperty("--wp-admin-bar-height", ((_a = adminBar === null || adminBar === void 0 ? void 0 : adminBar.clientHeight) !== null && _a !== void 0 ? _a : 0) + "px");
            var nav = document.querySelector("#site-nav");
            setCSSCustomProperty("--nav-height", ((_b = nav === null || nav === void 0 ? void 0 : nav.clientHeight) !== null && _b !== void 0 ? _b : 0) + "px");
            var footer = document.querySelector("#site-footer");
            setCSSCustomProperty("--footer-height", ((_c = footer === null || footer === void 0 ? void 0 : footer.clientHeight) !== null && _c !== void 0 ? _c : 0) + "px");
        };
        windowResizeHandler();
        window.addEventListener("resize", windowResizeHandler);
        var updateSubMenuHeight = function () { return __awaiter(void 0, void 0, void 0, function () {
            var subMenus, subMenuHeights, menuItems, menuItemHeights;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tick()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, tick()];
                    case 2:
                        _a.sent();
                        subMenus = document.querySelectorAll("#site-nav .sub-menu");
                        subMenuHeights = [];
                        subMenus.forEach(function (el) { return subMenuHeights.push(el.clientHeight); });
                        setCSSCustomProperty("--sub-menu-height", Math.max.apply(Math, __spreadArray([], __read(subMenuHeights), false)) + "px");
                        menuItems = document.querySelectorAll("#site-nav .menu-item");
                        menuItemHeights = [];
                        menuItems.forEach(function (el) { return menuItemHeights.push(el.clientHeight); });
                        setCSSCustomProperty("--menu-item-height", Math.max.apply(Math, __spreadArray([], __read(menuItemHeights), false)) + "px");
                        return [2 /*return*/];
                }
            });
        }); };
        var nav = document.querySelector("#site-nav");
        if (nav) {
            nav.onpointerenter = updateSubMenuHeight;
            updateSubMenuHeight();
        }
    },
    initGPDRManager: function () {
        // If you are testing and have clicked 'I consent', you can either open the site in an incognito tab, or run GDPR_CONSENT.reset() in your console to clear the local storage key. Refresh afterwards and you will see the banner again.
        // @ts-ignore
        GDPR_MANAGER.init({
            // delay: 1000, /** milliseconds to delay the banner from appearing. This only delays the banner and does not delay the onConsentValid function. */
            banner: {
                title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V9C15 9.55228 14.5523 10 14 10H10C9.44772 10 9 9.55228 9 9V8ZM6 10C6.55228 10 7 9.55228 7 9V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9C17 9.55228 17.4477 10 18 10V10C18.5523 10 19 10.4477 19 11V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V11C5 10.4477 5.44772 10 6 10V10ZM12 17C11.4477 17 11 16.5523 11 16V14C11 13.4477 11.4477 13 12 13V13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17V17Z" fill="white"/></svg>We Value Your Privacy',
                bodyHtml: "<p>Aperture Glazing uses cookies and similar technologies to analyse traffic and app usage. Some are necessary for our website and application to work properly and can't be switched off, and some are optional but helps us support the experience for you and help improve services for all clients.</p>",
                showRemindMeLaterButton: false,
                showManageButton: true,
                style: {
                    backgroundColorFallback: "#4A4181" /** used when backdrop blur is not available */,
                    backgroundColor: "#4A4181" /** change the last number to adjust opacity, from 0 to 1 */,
                    backgroundImage: "linear-gradient(336.96deg, #4A4181 -17.01%, #29234F 140.47%)",
                    backdropBlur: false /** Background color must be transparent for backdrop blur to work */,
                    foregroundColor: "#ffffff",
                    linkColor: "#009FE3",
                    headingColor: "inherit",
                    buttonBackgroundColor: "rgba(255,255,255,.15)",
                    buttonForegroundColor: "#ffffff",
                    buttonBorderRadius: "5px",
                },
            },
            privacySettingsPanelConfig: {
                title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V9C15 9.55228 14.5523 10 14 10H10C9.44772 10 9 9.55228 9 9V8ZM6 10C6.55228 10 7 9.55228 7 9V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9C17 9.55228 17.4477 10 18 10V10C18.5523 10 19 10.4477 19 11V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V11C5 10.4477 5.44772 10 6 10V10ZM12 17C11.4477 17 11 16.5523 11 16V14C11 13.4477 11.4477 13 12 13V13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17V17Z" fill="white"/></svg><span>Cookie & Privacy Settings</span>',
                style: {
                    panelBackgroundColor: "#4A4181",
                    panelForegroundColor: "#ffffff",
                    panelBackgroundImage: "linear-gradient(356.95deg, #4A4181 -2.75%, #241D4B 99.82%);",
                },
                ESSENTIAL: {
                    description: [
                        "<p>Some cookies and similar technologies are used to run the website and application properly and cannot be turned off. This includes:</p>",
                        '<p>- This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>',
                    ].join(""),
                },
                FACEBOOK_PIXEL: {
                    defaultOn: false,
                    description: "Collects marketing and advertisement information. This helps us to get more users in need to find our services. You can know more about how Facebook Pixel manages cookies and user/device information on their website.",
                },
                GOOGLE: {
                    defaultOn: false,
                    description: "Collects site traffic and usage information. This provides insight to where our visitors are coming from, and how everyone uses our services. This helps us to get more users in need to find our services, and understand our users better, which enables us to analyse and improve our service offerings for everyone. You can know more about how Google Analytics manages cookies and user/device information on their website.",
                },
                contentAfterSaveButton: [
                    "<p><em>* You can change above settings for this browser at any time by visiting the Privacy Settings page from your account page or global settings available in different areas of the website and application.</em></p>",
                    "<h3>More Options</h3>",
                    '<a href="/page/privacy" title="GDPR & Privacy Policy">→ Read our GDPR & Privacy Policy</a>',
                ].join(""),
            },
            reloadPageOnFirstConsent: false,
            analyticalIDs: {
                // GTAG: 'GTM-WHQDCVB',
                GOOGLE_ANALYTICS: "UA-91086732-1",
                FACEBOOK_PIXEL: "1911107525841551",
            },
        });
    },
};
